import{createContext as t,useContext as n}from"react";const a=o=>{const e=t(o);return[e.Provider,()=>{const r=n(e);if(!r)throw new Error(`! ${e.displayName} was consumed without a provider`);return r}]};export{a as createContextHook};
//# sourceMappingURL=utilities.js.map
